import { FormattedMessage } from "react-intl";
import cx from "classnames";
import ThemeButton from '@/shared/ui/ThemeButton';
import { useHostingRequestModal } from '~/marketing';

type CustomAdminPanelRequestProps = {
  className?: string;
}

const CustomAdminPanelRequest = (props: CustomAdminPanelRequestProps) => {
  const {
    className
  } = props;
  const { openModal: openHostingRequestModal } = useHostingRequestModal();

  return (
    <div className={cx("flex items-center sm:items-start flex-col sm:flex-row", className)}>
      {/* <div className="sm:mr-10">
        <span className="theme-icon-svg" aria-hidden={true}>
          <Columns3Cog className="size-14 text-white/60 theme-color"/>
        </span>
      </div> */}
      <div className="w-full flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-8">
        <h2 className="text-xl md:text-3xl leading-7">
          <FormattedMessage id="l.btc.admin.t" values={{ span: (...chunks) => <span className="theme-text-highlight">{chunks}</span>, }} />
        </h2>
        <ThemeButton onClick={() => openHostingRequestModal()}>
          <FormattedMessage id="l.btc.admin.cta" />
        </ThemeButton>
      </div>
    </div>
  );
};

export default CustomAdminPanelRequest;
